import React, { useState, FormEvent } from "react";
import { Modal } from "../ui/modal";
import Button from "../ui/button/Button";
import type { ClienteB2C } from "../../hooks/useApi";

interface CreateClientModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddClient: (client: Omit<ClienteB2C, "id" | "reservations">) => Promise<ClienteB2C | void>;
  onSuccess?: (newClient: ClienteB2C) => void;
}

const CreateClientModal: React.FC<CreateClientModalProps> = ({
  isOpen,
  onClose,
  onAddClient,
  onSuccess
}) => {
  const [newClientData, setNewClientData] = useState({
    name: "",
    email: "",
    phone: "",
    documentoIdentidad: "",
  });

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    if (!newClientData.name || !newClientData.email || !newClientData.phone) {
      window.alert("Por favor complete todos los campos requeridos");
      return;
    }
    
    try {
      const newClient = await onAddClient({
        name: newClientData.name,
        email: newClientData.email,
        phone: newClientData.phone,
        documentoIdentidad: newClientData.documentoIdentidad.trim() || undefined,
        active: true
      });

      if (newClient) {
        setNewClientData({
          name: "",
          email: "",
          phone: "",
          documentoIdentidad: "",
        });
        
        if (onSuccess) {
          onSuccess(newClient);
        }
        onClose();
      }
    } catch (error) {
      if (error instanceof Error && error.message.includes("Ya existe un cliente")) {
        window.alert("Ya existe un cliente con ese email");
      } else {
        window.alert("Error al crear el cliente. Por favor, intente nuevamente.");
      }
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Crear nuevo cliente">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Nombre completo
          </label>
          <input
            type="text"
            value={newClientData.name}
            onChange={(e) => setNewClientData({ ...newClientData, name: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Correo electrónico
          </label>
          <input
            type="email"
            value={newClientData.email}
            onChange={(e) => setNewClientData({ ...newClientData, email: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Teléfono
          </label>
          <input
            type="tel"
            value={newClientData.phone}
            onChange={(e) => setNewClientData({ ...newClientData, phone: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Documento de identidad
          </label>
          <input
            type="text"
            value={newClientData.documentoIdentidad}
            onChange={(e) => setNewClientData({ ...newClientData, documentoIdentidad: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100"
            placeholder="Ingrese el número de documento"
          />
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button 
            variant="outline" 
            type="button" 
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button 
            variant="primary" 
            type="submit"
          >
            Crear cliente
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateClientModal; 